module.exports = __webpack_public_path__ + "media/images/samples/1280x768/15-5724f960a6bbd97bac85330170aa318a.jpg";